/**
 * Clinical Templates Data Points Index
 * Exports all data points organized by category
 */

import { dataPointSchema } from './schema'
import cardiacDataPoints from './cardiac'
import generalAppearanceDataPoints from './generalAppearance'
import generalDataPoints from './general'
import skinDataPoints from './skin'
import respiratoryDataPoints from './respiratory'
import { observationsDataPoints } from './observations'
import heentDataPoints from './heent'
import abdomenDataPoints from './abdomen'
import neurologicalDataPoints from './neurological'
import orthopaedicDataPoints from './orthopaedic'
import diagnosisDataPoints from './diagnosis'

// Export individual categories
export {
  dataPointSchema,
  cardiacDataPoints,
  generalAppearanceDataPoints,
  generalDataPoints,
  skinDataPoints,
  respiratoryDataPoints,
  observationsDataPoints,
  heentDataPoints,
  abdomenDataPoints,
  neurologicalDataPoints,
  orthopaedicDataPoints,
  diagnosisDataPoints
}

// Combined data points by category
export const allDataPoints = {
  General: generalDataPoints,
  Cardiac: cardiacDataPoints,
  'General Appearance': generalAppearanceDataPoints,
  Skin: skinDataPoints,
  Respiratory: respiratoryDataPoints,
  Observations: observationsDataPoints,
  HEENT: heentDataPoints,
  Abdomen: abdomenDataPoints,
  Neurological: neurologicalDataPoints,
  Orthopaedic: orthopaedicDataPoints,
  Diagnosis: diagnosisDataPoints
}

// Flattened array of all data points
export const flatDataPoints = [
  ...generalDataPoints,
  ...cardiacDataPoints,
  ...generalAppearanceDataPoints,
  ...skinDataPoints,
  ...respiratoryDataPoints,
  ...observationsDataPoints,
  ...heentDataPoints,
  ...abdomenDataPoints,
  ...neurologicalDataPoints,
  ...orthopaedicDataPoints,
  ...diagnosisDataPoints
]

// Get data points by category
export const getDataPointsByCategory = (category) => {
  return allDataPoints[category] || []
}

// Get data point by ID
export const getDataPointById = (id) => {
  return flatDataPoints.find((point) => point.id === id)
}

// Get all categories
export const getCategories = () => {
  return Object.keys(allDataPoints)
}

// Get subcategories for a category
export const getSubcategories = (category) => {
  const categoryPoints = getDataPointsByCategory(category)
  const subcategories = [...new Set(categoryPoints.map((point) => point.subcategory))]
  return subcategories.filter(Boolean)
}

// Validate data point against schema
export const validateDataPoint = (dataPoint) => {
  // Basic validation - in a real implementation, you'd use a JSON schema validator
  const required = ['id', 'label', 'category', 'fieldType', 'isActive']
  const missing = required.filter((field) => !dataPoint.hasOwnProperty(field))

  if (missing.length > 0) {
    throw new Error(`Missing required fields: ${missing.join(', ')}`)
  }

  return true
}

export default allDataPoints
